import { Checkbox } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { useTranslation } from 'react-i18next';

export const IncludeBadQualityField = () => {
  const { t } = useTranslation();
  const { getInputProps, values } = useCreateRuleFormContext();

  return (
    <Checkbox
      mt={'xs'}
      label={t('include_bad_quality_label')}
      {...getInputProps('data.heartRhythmMeasurement.includeBadQuality', { type: 'checkbox' })}
      disabled={values.formDisabled}
    />
  );
};
